
    <!--Carga el componente segun la ruta que este en la url-->
    <router-outlet></router-outlet>

















